var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import DisplayManagerContext from '../../context/display-manager-context';
import WindowStateContext from '../../context/window-state-context';
import { getGeometryStyle } from '../../helpers/styles';
var StyledPanel = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  box-sizing: ", ";\n  background: ", ";\n  ", "\n"], ["\n  ", "\n  ", "\n  box-sizing: ", ";\n  background: ", ";\n  ",
    "\n"])), function (_a) {
    var hidden = _a.hidden;
    return (hidden ? 'display: none;' : '');
}, function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.panel.boxSizing;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.panel.background;
}, function (_a) {
    var attributes = _a.attributes, windowTheme = _a.windowTheme;
    var _b = attributes.frameShadow, frameShadow = _b === void 0 ? '' : _b, _c = attributes.frameShape, frameShape = _c === void 0 ? '' : _c;
    if (frameShape.trim().toLowerCase() != 'noframe') {
        switch (frameShadow.trim().toLowerCase()) {
            case 'raised':
                return "\n                      border: " + windowTheme.panel.raised.border + ";\n                      border-left-color: " + windowTheme.panel.raised.borderColor.left + ";\n                      border-top-color: " + windowTheme.panel.raised.borderColor.top + ";\n                      border-right-color: " + windowTheme.panel.raised.borderColor.right + ";\n                      border-bottom-color: " + windowTheme.panel.raised.borderColor.bottom + ";\n                  ";
            case 'sunken':
                return "\n                      border: " + windowTheme.panel.sunken.border + ";\n                      border-right-color: " + windowTheme.panel.sunken.borderColor.right + ";\n                      border-bottom-color: " + windowTheme.panel.sunken.borderColor.bottom + ";\n                      border-left-color: " + windowTheme.panel.sunken.borderColor.left + ";\n                      border-top-color: " + windowTheme.panel.sunken.borderColor.top + ";\n                  ";
            default:
                return "";
        }
    }
    return "";
});
var Panel = function (props) {
    var fields = useContext(WindowStateContext).fields;
    var identifier = props.identifier, form = props.form, type = props.type, restProps = __rest(props, ["identifier", "form", "type"]);
    var displayManger = useContext(DisplayManagerContext);
    var hidden = isHidden(fields, identifier, displayManger, restProps.attributes);
    return React.createElement(StyledPanel, __assign({ id: identifier }, restProps, { hidden: hidden }));
};
var isHidden = function (fields, identifier, displayManager, attributes) {
    if (attributes.visibleExpression) {
        return !eval(attributes.visibleExpression);
    }
    return displayManager[identifier];
};
export default Panel;
var templateObject_1;
//# sourceMappingURL=index.js.map